import { defineStore, StoreDefinition } from "pinia";
import { computed, ref } from "vue";

export type AppState = StoreDefinition<"appState", () => any>;


export const useAppState =  defineStore("appState", () => {
    // --- State  --------------------------------------- //
    /* ref()s become state properties */
    const loading        = ref<boolean>( true);
    const l2CModalOpen = ref<boolean>(false);
    // --- Getters -------------------------------------- //
    /* computed()s become getters */
    // --- Actions -------------------------------------- //
    /* function()s become actions */
    const setLoading      = () => loading.value =  true;
    const setFinished     = () => loading.value = false;
    const setL2CModalClosed  = () => l2CModalOpen.value = false;
    const setL2CModalOpen    = () => l2CModalOpen.value =  true;
    return{
        loading,
        setLoading,
        setFinished,
        l2CModalOpen,
        setL2CModalClosed,
        setL2CModalOpen,
    }
});